// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import {SimCameraService, SimChecklistService} from "@services";
import {from, Observable, of} from "rxjs";
import {Camera, Checklist} from "@models";

@Pipe({
	name: "getCameraById",
	standalone: false,
})
export class GetCameraByIdPipe implements PipeTransform {
	constructor(private _simCameraService: SimCameraService) {}

	transform(cameraId: string): Observable<Camera> {
		if (!cameraId) {
			return of(null);
		}
		return from(this._simCameraService.getCameraById(cameraId));
	}
}
